<template>
  <WithTips icon="bi-x" iconColor="#F40000" :buttonBack="true" :buttonRestart="true" :buttonNext="false">
    <template #title>
      <span v-safe-html="$t('game.preGameModalChecksBadInternet.title')"></span>
    </template>
    <template #text>
      <span v-safe-html="$t('game.preGameModalChecksBadInternet.text')"></span>
    </template>
    <template #subtext>
      <span v-safe-html="$t('game.preGameModalChecksBadInternet.subtext')"></span>
    </template>
    <template #tipsTop>
      <span v-safe-html="$t('game.preGameModalChecksBadInternet.tipsTop')"></span>
    </template>
    <template #tipsList>
      <li v-safe-html="$t('game.preGameModalChecksBadInternet.tip1')"></li>
      <li v-safe-html="$t('game.preGameModalChecksBadInternet.tip2')"></li>
      <li v-safe-html="$t('game.preGameModalChecksBadInternet.tip3')"></li>
      <li v-safe-html="$t('game.preGameModalChecksBadInternet.tip4')"></li>
      <li v-safe-html="$t('game.preGameModalChecksBadInternet.tip5')"></li>
    </template>
    <template #tipsBottom>
      <span v-safe-html="$t('game.preGameModalChecksBadInternet.tipsBottom')"></span>
    </template>
  </WithTips>
</template>

<style lang="scss" scoped></style>

<script setup lang="ts">
import WithTips from "./WithTips.vue";
</script>
